module.exports = __webpack_public_path__ + "static/6328-a14128d97866810de62e15b017365214.png";